import { createRootRouteWithContext, HeadContent, Outlet, Scripts } from '@tanstack/react-router'
import type { AppRouterContext } from '@/trpc/context.ts'

export const Route = createRootRouteWithContext<AppRouterContext>()({
  head: () => ({
    links: [
      { rel: 'icon', href: '/favicon.ico?v=2', sizes: '16x16 32x32 48x48 64x64 128x128 256x256' },
      { rel: 'icon', href: '/logo.svg', type: 'image/svg+xml' },
      { rel: 'apple-touch-icon', href: '/logo192.png?v=2', sizes: '192x192' },
      { rel: 'manifest', href: '/manifest.json' }
    ],
    meta: [
      {
        name: 'description',
        content: 'Super Mega 租赁管理一体化智能系统'
      },
      {
        title: 'Super Mega'
      }
    ]
  }),
  component: RootComponent
})

function RootComponent() {
  return (
    <>
      <HeadContent />
      <Outlet />
      <Scripts />
    </>
  )
}
